import React from 'react';
import { Container, Col, Row } from "reactstrap"
import OfferCard from "../../components/OfferCard";

function Feed() {

  const exampleOffers = [
    {
      id: 1,
      guid: '12345',
      estimated_earnings_msr: 240,
      estimated_minutes_to_complete: 7,
      title: 'A test offer',
      description: 'This is a quick test offer.',
      image_url: 'https://d3s00xghdjywqy.cloudfront.net/survey-img/pattern-lights-2x1.jpg',
    },
    {
      id: 2,
      guid: '67890',
      estimated_earnings_msr: 120,
      estimated_minutes_to_complete: 3,
      title: 'Another offer',
      description: 'This is another offer that has a long description and no image.',
      image_url: null,
    }
  ];

  return (
    <Container fluid="sm">
      <Row>
        <Col>
          <h1>Feed</h1>
        </Col>
      </Row>
      {exampleOffers.map(offer => (
        <Row key={offer.id}>
          <Col>
            <OfferCard offer={offer} />
          </Col>
        </Row>
      ))}
    </Container>
  );
}

export default Feed;
